'use strict';

var baseSearch = require('base/search/search');
var tile = require('../product/tile');

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateGtmDataLayer(response) {
    var $tempDom = $('<div>').append($(response));
    var eccViewItemIist = $tempDom.find('.grid-footer').data('ecc-view-item-list');
    if (eccViewItemIist) {
        window.dataLayer.push(eccViewItemIist);
    }
}


function showMore() {
    // Show more products
    $('.container, .container-fluid').on('click', '.show-more button', function (e) {
        e.stopPropagation();
        var showMoreUrl = $(this).data('url');
        e.preventDefault();

        $.spinner().start();
        $(this).trigger('search:showMore', e);
        $.ajax({
            url: showMoreUrl,
            data: { selectedUrl: showMoreUrl },
            method: 'GET',
            success: function (response) {
                // Check if the response contains product tiles, assuming then it was on the PLP
                $('.grid-footer').replaceWith(response);
                $('body').trigger('search:updateDom', '.grid-footer');
                updateSortOptions(response);
                updateGtmDataLayer(response);

                // Added here to handle view more button click when the page is loaded
                // This will work with normal and Page Designer loaded pages
                if (response.indexOf('<div class="product-tile">') >= 0) {
                    // Get the updated permalink on the page from the updated DOM
                    var _historyLink = decodeURI($('input.permalink').val());
                    _historyLink ? window.history.pushState({}, null, _historyLink) : null;
                }

                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
}

// In Stock filter
// Handle the in-stock slider toggle
function handleInStockSlider() {
    $('.js-instock-search').on('change', function() {
        $.spinner().stop();
        if ($(this).is(':checked')) {
            updateURLParamsWithInstock(true);
            localStorage.setItem('instockSlider', 'true');
        } else {
            updateURLParamsWithInstock(false);
            localStorage.setItem('instockSlider', 'false');
        }

        window.location.reload();
    });
}

/**
 * Check and fix parameters if instock was removed 
 * If there is a missing parameter in the index order update the missing index with the last parameter
 * @param {*} params 
 */
function checkAndFixParameters(params) {
    var paramNumbers = [];
    params.forEach((value, key) => {
        let match = key.match(/^prefn(\d+)$/);
        if (match) {
            let num = parseInt(match[1], 10);
            paramNumbers.push(num)
        }
    });
    if (paramNumbers.length) {
        var lastIndex = paramNumbers[paramNumbers.length - 1];
        for (let i = 0; i < paramNumbers.length; i++) {
            let parameterIndex = paramNumbers[i];
            if (parameterIndex !== i+1) {
                let missingIndex = i+1;
                // Switch last index with the missing index after instock filter was removed 
                params.set(`prefn${missingIndex}`, params.get(`prefn${lastIndex}`));
                params.set(`prefv${missingIndex}`, params.get(`prefv${lastIndex}`));
                // Clean up switched param index 
                params.delete(`prefn${lastIndex}`);
                params.delete(`prefv${lastIndex}`);
            }
        }
    }
}

// Update URL parameters to include or remove 'instock' filter, return true if modified and reload needed
function updateURLParamsWithInstock(inStock) {
    var url = new URL(window.location.href);
    var params = new URLSearchParams(url.search);

    let instockExists = false;
    let instockKeys = [];
    let maxN = 0;
    let modified = false; // Track if modifications were made
    // Instock is being removed and there are existing parameters that could be out of order
    let needToCheckParams = params.size > 2 && inStock === false;

    // Iterate over parameters to find existing 'instock' filters and max index
    params.forEach((value, key) => {
        let match = key.match(/^prefn(\d+)$/);
        if (match) {
            let num = parseInt(match[1], 10);
            if (num > maxN) {
                maxN = num;
            }
            if (value === 'instock') {
                instockExists = true;
                instockKeys.push(num);
            }
        }
    });

    if (inStock) {
        // If 'instock' already exists, do nothing
        if (instockExists) {
            return false;
        }

        // Add new 'instock' filter
        let nextN = maxN + 1;
        params.set(`prefn${nextN}`, 'instock');
        params.set(`prefv${nextN}`, 'true');
        modified = true;
    } else {
        // Remove all 'instock' filters
        if (instockKeys.length > 0) {
            instockKeys.forEach(n => {
                params.delete(`prefn${n}`);
                params.delete(`prefv${n}`);
            });
            if (needToCheckParams) {
                checkAndFixParameters(params);
            }
            modified = true;
        }
    }

    // If no modifications were made, return true
    if (!modified) {
        return false;
    }

    // Update URL without reloading the page
    url.search = params.toString();
    window.history.pushState({}, '', url);

    return true; // Indicate that a modification was made
}

// Update menu URL to apply 'instock' filter before navigate to the category page
function handleMenuClick(inStock) {
    $('.main-menu .dropdown-link').on('click', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var url = href;

        url = inStock ? url + '?prefn1=instock&prefv1=true' : url; 
        window.location.href = url;
    });
}

function loadInstockConfigurations() {
    // In-stock filter
    var instockSlider = localStorage.getItem('instockSlider');
    var needUpdate = false;

    if (instockSlider === 'true') {
        needUpdate = updateURLParamsWithInstock(true);
        handleMenuClick(true);
        $('.js-instock-search').prop('checked', true);
    } else {
        needUpdate = updateURLParamsWithInstock(false);
        handleMenuClick(false);
        $('.js-instock-search').prop('checked', false);
    }

    // In case if used opened in the new tab, so request was done without updated URL
    if (needUpdate) {
        $.spinner().start();
        var searchUrl = window.location.href;

        $.ajax({
            url: searchUrl,
            data: {
                page: $('.grid-footer').data('page-number'),
                selectedUrl: searchUrl
            },
            method: 'GET',
            success: function (response) {
                parseResults(response);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    } 
}
// In-stock filter end

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    $('body').trigger('search:updateDom', selector);
    loadInstockConfigurations();
    handleInStockSlider();
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

function applyFilter() {
    // Handle refinement value selection and reset click
    $('.container, .container-fluid').on(
        'click',
        '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
        function (e) {
            e.preventDefault();
            e.stopPropagation();

            $(this).trigger('search:filter', e);

            var searchUrl = $(this).data('href');
            var seoUrl = $(this).data('seo-href') || searchUrl;
            if (seoUrl) {
                window.history.pushState({}, null, seoUrl);
            }

            var attributeId = '#' + $(this).find('span').last().attr('id');
            $.ajax({
                url: searchUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: searchUrl
                },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    $(attributeId).parent('button').focus();
                },
                error: function () {
                    $(attributeId).parent('button').focus();
                }
            });
        }
    );
}

function load() {
    var eccViewItemIist = $('.grid-footer').data('ecc-view-item-list');

    if (eccViewItemIist) {
        window.dataLayer.push(eccViewItemIist);
    }

    loadInstockConfigurations();
    // TODO: Rework this fix : Fall safe for edge case
    // if it's an empty results page clear the in-stock preference
    // So User doesn't get stuck in loop if results are empty due to preference
    if ($('.js-empty-search-result').length && window.location.href.indexOf('instock') !== -1) {
        localStorage.setItem('instockSlider', 'false');
    }
}

// Handle back button positioning
function handleBackButton() {
    $(window).on("unload", function() {
        var scrollPosition = $(window).scrollTop();
        localStorage.setItem("scrollPosition", scrollPosition);
    });

    $(window).on("load", function () {
        setTimeout(function() {
            if (localStorage.scrollPosition) {
                $(window).scrollTop(localStorage.getItem("scrollPosition"));
            }
        }, 10);
    });
}

function sort() {
    // Handle sort order menu selection
    $('.container, .container-fluid').on('change', '[name=sort-order]', function (e) {
        e.preventDefault();

        $.spinner().start();
        $(this).trigger('search:sort', this.value);
        $.ajax({
            url: this.value,
            data: { selectedUrl: this.value },
            method: 'GET',
            success: function (response) {
                $('.product-grid').empty().html(response);
                $('body').trigger('search:updateDom', '.product-grid');
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
}

function filter() {
    // Display refinements bar when Menu icon clicked
    $('.container, .container-fluid').on('click', 'button.filter-results', function () {
        $('.refinement-bar, .modal-background').show();
        $('.refinement-bar').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
        $('.refinement-bar .close').focus();
    });
}

function closeRefinements () {
    // Refinements close button
    $('.container, .container-fluid').on('click', '.refinement-bar button.close, .modal-background, .refinement-bar button.apply-filters-btn', function () {
        $('.refinement-bar, .modal-background').hide();
        $('.refinement-bar').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        $('.btn.filter-results').focus();
    });
}

function showContentTab() {
    // Display content results from the search
    $('.container, .container-fluid').on('click', '.content-search', function () {
        if ($('#content-search-results').html() === '') {
            getContent($(this), $('#content-search-results'));
        }
    });

    // Display the next page of content results from the search
    $('.container, .container-fluid').on('click', '.show-more-content button', function () {
        getContent($(this), $('#content-search-results'));
        $('.show-more-content').remove();
    });
}

var exportDetails = $.extend({}, baseSearch, {
    applyFilter: applyFilter,
    closeRefinements: closeRefinements,
    filter: filter,
    handleBackButton: handleBackButton,
    handleInStockSlider: handleInStockSlider,
    load: load,
    selectVariation: tile.selectVariation,
    showContentTab:showContentTab,
    showMore: showMore,
    sort: sort
});

module.exports = exportDetails;
